import { render, staticRenderFns } from "./CouponChecker.vue?vue&type=template&id=784ab4ac&scoped=true"
import script from "./CouponChecker.vue?vue&type=script&lang=js"
export * from "./CouponChecker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784ab4ac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CouponItem: require('/home/korzinka/www/front/components/CouponItem.vue').default})
